module.exports = __webpack_public_path__ + "9066bc8a2d9d8704e7dccf3b98635278.MP3";